<template>
    <div class="brand-backdrop" :class="{ 'brand-backdrop--adaptive': adaptive, 'brand-backdrop--fade': fade }">
        <div class="brand-backdrop__glows"></div>
        <div class="brand-backdrop__dots"></div>
        <div class="brand-backdrop__rings"></div>
    </div>
</template>

<script>
export default {
    name: 'BrandBackdrop',
    props: {
        adaptive: {
            type: Boolean,
            default: false,
        },
        fade: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>
.brand-backdrop {
    position: absolute;
    inset: 0;
    overflow: hidden;
    background: #06080C;
}

.brand-backdrop__glows {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(ellipse 70% 60% at 30% 40%, rgba(204, 255, 51, 0.12) 0%, transparent 70%),
        radial-gradient(ellipse 60% 70% at 75% 70%, rgba(51, 153, 153, 0.14) 0%, transparent 65%),
        radial-gradient(ellipse 40% 40% at 60% 20%, rgba(102, 204, 204, 0.08) 0%, transparent 60%);
}

.brand-backdrop__dots {
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.06) 1.5px, transparent 1.5px);
    background-size: 32px 32px;
    background-repeat: repeat;
}

.brand-backdrop__rings {
    position: absolute;
    inset: 0;
    overflow: hidden;
}

.brand-backdrop__rings::before {
    content: '';
    position: absolute;
    top: -80px;
    left: -80px;
    width: 420px;
    height: 420px;
    border-radius: 50%;
    border: 1px solid rgba(204, 255, 51, 0.08);
}

.brand-backdrop__rings::after {
    content: '';
    position: absolute;
    bottom: -100px;
    right: -60px;
    width: 500px;
    height: 500px;
    border-radius: 50%;
    border: 1px solid rgba(51, 153, 153, 0.1);
}

.brand-backdrop--fade .brand-backdrop__glows,
.brand-backdrop--fade .brand-backdrop__dots,
.brand-backdrop--fade .brand-backdrop__rings {
    animation: brand-backdrop-in .5s ease-out both;
}

@keyframes brand-backdrop-in {
    from { opacity: 0; }
    to { opacity: 1; }
}

.theme--light .brand-backdrop--adaptive {
    background: #E8F0EC;
}

.theme--light .brand-backdrop--adaptive .brand-backdrop__glows {
    background:
        radial-gradient(ellipse 70% 60% at 30% 40%, rgba(204, 255, 51, 0.55) 0%, transparent 70%),
        radial-gradient(ellipse 60% 70% at 75% 70%, rgba(102, 204, 204, 0.45) 0%, transparent 65%),
        radial-gradient(ellipse 40% 40% at 60% 20%, rgba(51, 153, 153, 0.22) 0%, transparent 60%);
}

.theme--light .brand-backdrop--adaptive .brand-backdrop__dots {
    background-image: radial-gradient(circle, rgba(15, 22, 35, 0.07) 1.5px, transparent 1.5px);
}

.theme--light .brand-backdrop--adaptive .brand-backdrop__rings::before {
    border-color: rgba(51, 153, 153, 0.18);
}

.theme--light .brand-backdrop--adaptive .brand-backdrop__rings::after {
    border-color: rgba(51, 153, 153, 0.2);
}
</style>
